import script from "./mainHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./mainHeader.vue?vue&type=script&setup=true&lang=js"

import "./mainHeader.vue?vue&type=style&index=0&id=7902e50e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7902e50e"]])

export default __exports__